<template>
  <v-navigation-drawer v-model="inputedValue" fixed temporary right width="320">
    <v-toolbar-title class="drawerTitle primary">
      <span v-if="!selectedItem">{{ $t('common.common_notification') }}</span>
      <span
        v-else
        class="back ml-n3 d-flex align-center"
        @click="selectedItem = null"
      >
        <v-icon class="baseText--text pr-1" size="30">mdi-chevron-left</v-icon>
        {{ $t('common.common_back') }}
      </span>
      <v-btn icon @click="close()" large>
        <v-icon class="white--text"> mdi-close </v-icon>
      </v-btn>
    </v-toolbar-title>
    <!-- 一覧 -->
    <transition name="slide" mode="out-in">
      <template v-if="!selectedItem">
        <div v-if="items.length <= 0" class="emptyContent">
          {{ $t('common.common_no-info') }}
        </div>
        <v-list v-else dense three-line class="py-0 noticeContent">
          <template v-for="(item, index) in items">
            <v-list-item
              :key="index"
              link
              class="pl-5 pr-3"
              @click="selectedItem = item"
            >
              <v-list-item-content>
                <v-row no-gutters class="h100p pb-1">
                  <v-col>
                    <v-row no-gutters class="d-flex align-center">
                      <v-col class="pa-0">
                        <v-chip
                          class="ma-2 ml-0 noticeType"
                          :color="TYPE_INFO[item.type].COLOR"
                          text-color="white"
                          x-small
                        >
                          {{ $t(TYPE_INFO[item.type].LABEL) }}
                        </v-chip>
                      </v-col>
                      <v-col class="pa-0 text-right">
                        <span class="noticeDate">
                          {{ item.startDatetime | dateFormat }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-list-item-title class="noticeTitle">{{
                      item.title
                    }}</v-list-item-title>
                  </v-col>
                </v-row>
              </v-list-item-content>
              <v-icon class="arrow pl-0 pr-0">mdi-chevron-right</v-icon>
            </v-list-item>
            <v-divider :key="'divider_' + index"></v-divider>
          </template>
        </v-list>
      </template>

      <!-- 詳細 -->
      <template v-else>
        <div class="px-5 py-2">
          <v-row no-gutters class="d-flex align-center">
            <v-col class="pa-0">
              <v-chip
                class="ma-2 ml-0 noticeType"
                :color="TYPE_INFO[selectedItem.type].COLOR"
                text-color="white"
                x-small
              >
                {{ $t(TYPE_INFO[selectedItem.type].LABEL) }}
              </v-chip>
            </v-col>
            <v-col class="pa-0 text-right">
              <span class="noticeDate isDetail mr-0">
                {{ selectedItem.startDatetime | dateFormat }}
              </span>
            </v-col>
          </v-row>
          <v-row no-gutters class="noticeTitle isDetail">
            {{ selectedItem.title }}
          </v-row>
          <v-row no-gutters class="noticeBody">
            {{ selectedItem.body }}
          </v-row>
        </div>
      </template>
    </transition>
  </v-navigation-drawer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {},
  props: {
    value: { default: null }
  },
  data: () => ({
    items: [],
    selectedItem: null
  }),
  filters: {
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  async created() {
    await this.getNoticeListFromApi()
    this.items = this.getNoticeListFromState()
  },
  methods: {
    ...mapActions('Notice', ['getNoticeListFromApi']),
    ...mapGetters('Notice', ['getNoticeListFromState']),
    close() {
      this.inputedValue = false
    }
  },
  computed: {
    // TODO: masterデータが提供されていないので仮です
    TYPE() {
      return {
        INFO: 1,
        MAINTENANCE: 2,
        ACCIDENT: 3
      }
    },
    TYPE_INFO() {
      return {
        [this.TYPE.INFO]: {
          LABEL: 'common.common_notification',
          COLOR: '#004e88'
        },
        [this.TYPE.MAINTENANCE]: {
          LABEL: 'common.common_maintenance-info',
          COLOR: '#ff8f00'
        },
        [this.TYPE.ACCIDENT]: {
          LABEL: 'common.common_failure-info',
          COLOR: '#cd4444'
        }
      }
    },
    inputedValue: {
      get() {
        return this.value
      },
      async set(newValue) {
        this.$emit('input', newValue)

        // ナビゲーションが閉じるまでのチラつき防止で初期化を少し待つ
        await new Promise((r) => setTimeout(r, 100))
        this.selectedItem = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.drawerTitle {
  color: #fff;
  font-size: 18px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 18px;
  padding-right: 5px;
  font-weight: bold;
  justify-content: space-between;
  .back {
    cursor: pointer;
  }
}
.emptyContent {
  margin-left: 18px;
  margin-top: 18px;
  color: #666666;
}
.noticeContent {
  overflow: auto;
  height: calc(100% - 50px);
}
.noticeDate {
  font-size: 12px;
  color: #aaaaaa;
  margin-right: 8px;
  &.isDetail {
    padding-right: 2px;
  }
}
.noticeType {
  font-size: 12px;
  height: 18px;
  border-radius: 10px;
}
.noticeTitle {
  font-size: 14px !important;
  line-height: 1.57 !important;
  color: #333;
  font-weight: bold !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-all;
  &.isDetail {
    display: block;
    -webkit-line-clamp: initial;
    white-space: initial;
    overflow: auto;
  }
}
.noticeBody {
  font-size: 12px;
  color: #666666;
  margin-top: 14px;
  line-height: 1.92;
  letter-spacing: normal;
  white-space: pre-line;
}
.arrow {
  color: #000;
  opacity: 0.15;
  margin-left: 4px;
}
.h100p {
  height: 100%;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.23s ease-in-out;
}
.slide-enter,
.slide-leave-active {
  transform: translateX(-5px);
  opacity: 0;
}
</style>
